export enum NavCategory {
  All = 'All',
  Bestsellers = 'Bestsellers',
  Sculptwear = 'Sculptwear',
  Tops = 'Tops',
  Bras = 'Bras',
  Bodysuits = 'Bodysuits',
  Underwear = 'Underwear',
  LiftWear = 'LiftWear',
  Bottoms = 'Bottoms',
  Discounted = 'Discounted',
}
